<div>
    <div class="row mt-5">
        <div class="col-sm-12 col-12">
            <div class="form-group">
                <label for="text" class="mb-3"> {{"Trademark_info.TradeMarkInfo" | translate}} </label>
            </div>
        </div>
    </div>
    <form [formGroup]="form_Group">
        <div class="row">
            <div *ngIf="!isCRExternal && trademarks" class="col-sm-12 col-12 mb-4">
                <label class="mb-3">{{"Trademark_info.TradeMark" | translate}}</label>
                <select2 [data]="trademarks" [value]="form_Group.controls['tradeMarkId'].value"
                    (update)="getTrademarkInfo($event)" width="100%" resettable> </select2>
            </div>
            <div class="row col-md-12">
                <div class="col-sm-6 col-12" *ngIf="form_Group.controls['tradeMarkId'].value">
                    <div class="form-group">
                        <label for="text" class="mb-3">
                            {{"Trademark_info.TradeMarkNo" | translate}}
                        </label>
                        <input type="text" class="form-control" [value]="form_Group.controls['tradeMarkId'].value"
                            readonly />
                    </div>
                </div>
            </div>
            <div class=" row col-sm-12 col-12">
                <div class="col-sm-6 col-12">
                    <div class="form-group">
                        <label for="text" class="mb-3">
                            {{"Trademark_info.TradeMarkArabicName" | translate}}
                            <span class="text-danger"> *</span>
                        </label>
                        <input type="text" class="form-control" formControlName="tradeMarkArabicName"
                            placeholder="{{'Trademark_info.TradeMarkArabicName_p' | translate }}"
                            [readonly]="isSelectedTradeMarkId && tradeMarkArabicNameHasValue" />

                        <div class="text-danger mt-2">
                            <div
                                *ngIf="submitted && (form_Group.controls['tradeMarkArabicName'].hasError('minlength') || form_Group.controls['tradeMarkArabicName'].hasError('maxlength')) || !this.tradeMarkArabicNameLenghtValid">
                                {{"Trademark_info.TradeMarkArabicName_Length" | translate}}</div>
                            <div
                                *ngIf="submitted && form_Group.controls['tradeMarkArabicName'].hasError('pattern') || !this.tradeMarkArabicNamePattern">
                                {{"Trademark_info.TradeMarkArabicName_String" | translate}}</div>
                            <div
                                *ngIf="submitted && form_Group.controls['tradeMarkArabicName'].hasError('required') || !this.tradeMarkArabicNameRequired">
                                {{"Trademark_info.TradeMarkArabicName_Required" | translate}}</div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-12">
                    <div class="form-group">
                        <label for="text" class="mb-3">
                            {{"Trademark_info.TradeMarkEnglishName" | translate}}
                            <span class="text-danger"> *</span>
                        </label>
                        <input type="text" class="form-control" formControlName="tradeMarkEnglishName"
                            placeholder="{{'Trademark_info.TradeMarkEnglishName_p' | translate }}"
                            [readonly]="isSelectedTradeMarkId && tradeMarkEnglishNameHasValue" />
                        <div class="text-danger mt-2">
                            <div
                                *ngIf="submitted && (form_Group.controls['tradeMarkEnglishName'].hasError('minlength') || form_Group.controls['tradeMarkEnglishName'].hasError('maxlength')) || !this.tradeMarkEnglishNameLenghtValid">
                                {{"Trademark_info.TradeMarkEnglishName_Length" | translate}}</div>
                            <div
                                *ngIf="submitted && form_Group.controls['tradeMarkEnglishName'].hasError('pattern') || !this.tradeMarkEnglishNamePattern">
                                {{"Trademark_info.TradeMarkEnglishName_String" | translate}}</div>
                            <div
                                *ngIf="submitted && form_Group.controls['tradeMarkEnglishName'].hasError('required') || !this.tradeMarkEnglishNameRequired">
                                {{"Trademark_info.TradeMarkEnglishName_Required" | translate}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="mb-4">
                    <label class="mb-3">
                        {{"Trademark_info.TradeMarkLogo" | translate}}
                        <span class="text-danger"> *</span>
                        <p class="label-hint" *ngIf="!tradeMarkLogoHasValue">{{"Trademark_info.UploadFileInfoExt" |
                            translate}} </p>
                        <p class="label-hint" *ngIf="!tradeMarkLogoHasValue">{{"Trademark_info.UploadFileInfoSize" |
                            translate}} </p>
                    </label>
                    <div class="input-group">
                        <div *ngIf="!tradeMarkLogoHasValue" class="col-sm-12 text-center custom-file file-upload">
                            <file-upload class="w-100" [isRequired]="true" name="file" #tradeMarkLogofileUpload
                                (onSuccess)="fileUploadSuccess($event)" (onError)="fileUploadError($event)"
                                (onAttachment)="attachmentFiles($event)" [noOfFiles]="1" [objectId]="objectId"
                                [objectTypeId]="objectTypeId" [attachmentTypeId]="tradeMarkLogoAttachmentTypeId"
                                [extensions]="extensions">
                            </file-upload>
                        </div>
                    </div>
                    <div class="text-danger"
                        *ngIf="submitted && form_Group.controls['tradeMarkLogo'].hasError('required') || !this.tradeMarkLogoRequired">
                        {{"Trademark_info.TradeMarkLogo_Required" | translate}}</div>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group text-center">
                    <img class="w-50" *ngIf="tradeMarkLogoHasValue"
                        [src]="form_Group.controls['tradeMarkLogo'].value" />
                </div>
            </div>
        </div>
    </form>
</div>